import { MasterHelper } from '../../utilities';
import { FilterViewModel } from '../regulation';

export class SelfAssessmentMasterFilter {
    fromDate!: Date|null;
    toDate!: Date|null;
    // ruleBook: FilterViewModel[];
    assessmentTeam: FilterViewModel[];
    reviewTeam: FilterViewModel[];
    // searchQuery: FilterViewModel[];
    assessmentStatus: FilterViewModel[];
    reviewStatus: FilterViewModel[];
    enhancementStatus: FilterViewModel[];
    ruleConclusion: FilterViewModel[];
    // enhancementDetails: FilterViewModel[];
    enhancementTeam: FilterViewModel[];
    // part: FilterViewModel[];
    owner: FilterViewModel[];
    // regulatoryRuleFullRequirement: FilterViewModel[];
    // assessmentDetails: FilterViewModel[];
    // reviewDetails: FilterViewModel[];
    overallStatus: FilterViewModel[];
    gapTeam: FilterViewModel[];
    // overallConclusion: FilterViewModel[];
    // gapDetails: FilterViewModel[];
    gapStatus: FilterViewModel[];

    constructor() {
        this.fromDate = null;
        this.toDate = null;
        // this.ruleBook = [];
        this.assessmentTeam = [];
        this.reviewTeam = [];
        // this.searchQuery = [];
        this.assessmentStatus = [];
        this.reviewStatus = [];
        this.enhancementStatus = [];
        this.ruleConclusion = [];
        // this.enhancementDetails = [];
        this.enhancementTeam = [];
        // this.part = [];
        this.owner = [];
        // this.regulatoryRuleFullRequirement = [];
        // this.assessmentDetails = [];
        // this.reviewDetails = [];
        this.overallStatus = [];
        this.gapTeam = [];
        // this.overallConclusion = [];
        // this.gapDetails = [];
        this.gapStatus = [];
    }
}
